<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardIntro :cardContent="content" @funcRoute="funcRoute" />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardIntro from './components/CardIntro.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardIntro, LoadingMDL},
  name: 'CTT01',
  data() {
    return {
      content: {},
      lang: '',
      CheckWidth: window.innerWidth.toString(),
      courseCode: '',
      topicId: '',
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: '',
      startTime: '',
      loading: true,
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      courseTopicID: 'courses/getCourseTopicID',

      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.loading = false;
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
  },

  mounted() {},

  created() {
    this.onLoad();
  },

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `CTT01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    funcRoute(val) {
      //next update
      //data form
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //dispatch
      this.$store.dispatch('v3/saveContent', data);
      //next after update
      const nextPath = `/v3/${val[0]}/${val[1]}`;

      this.$router.push(nextPath);

      // if (typeof val === 'string') {
      //   console.log('here val string');
      //   // this.nextAction = this.$helpers.setChineseUrl(val);
      // } else {
      //   console.log('here next');

      //   // this.$store.commit('necessary/setCodePage', val[1]);
      //   // this.nextAction = '/' + val[0] + '/' + val[1];
      // }
      //update userData
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section: this.courseSection,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: [],
      // });
      /*
      this.$store.dispatch(
        "template/saveUserTemplateData",
        this.userTemplateData
      );
      */
    },
  },
};
</script>
<style></style>
